export default "__VITE_ASSET__CB73rphg__"